import React from "react";
import { Box, CustomMultiSelect, ItemType, MultiSelectCustomTarget, TitleComponent } from "ui-components";
import { SIC_CODE_OBJ } from "../../../../utils/constants";

type Props = {
	values: string[];
	setValues: (values: string[]) => void;
};

const SicCodeMultiSelect = ({ values, setValues }: Props) => {
	const customTarget = values.length;
	const renderCustomTarget = (selectedItems: ItemType[]) => (
		<MultiSelectCustomTarget
			count={selectedItems.length}
			text={`SIC Codes selected`}
		/>
	);

	return (
		<Box flexDir="row" items="center" justify="between" minWidth={"large"}>
			<TitleComponent fontSize="15px" marginRight="30px" marginTop="5px" className="white-space-no-wrap" >
				Sic Codes:
			</TitleComponent>
			<CustomMultiSelect
				items={SIC_CODE_OBJ ?? []}
				values={values ?? []}
				onSelect={(item: ItemType) => {
					let newValues: string[];
					const valueStr = String(item.value).toUpperCase();

					if (!values.includes(valueStr)) {
						newValues = [...values, valueStr];
						setValues(newValues);
					} else {
						newValues = values.filter(v => v !== valueStr);
						setValues(newValues);
					}

				}}
				onRemove={(item) => {
					const valueStr = String(item).toUpperCase();
					const newValues = values.filter(v => v !== valueStr);
					setValues(newValues);
				}}
				customTarget={customTarget ? renderCustomTarget : undefined}
			/>
		</Box>
	);
};

export default SicCodeMultiSelect;
